import { render, staticRenderFns } from "./Carousel2.vue?vue&type=template&id=2a0d7c6c&scoped=true"
import script from "./Carousel2.vue?vue&type=script&lang=js"
export * from "./Carousel2.vue?vue&type=script&lang=js"
import style0 from "./Carousel2.vue?vue&type=style&index=0&id=2a0d7c6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0d7c6c",
  null
  
)

export default component.exports